module.exports = __webpack_public_path__ + "static/media/veterano_o.116d6668.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/veterano_o.png
// module id = 1151
// module chunks = 0